import { v1 as uuid } from 'uuid'

import { Mutation } from './Mutation'
import { sections, contentHash } from './Discover'
import { campaignSignUpContent, roleSignUpContent } from './SignUp'
import { LocalResolvers } from '@sketch/gql-types/resolvers'

export const localResolvers: LocalResolvers = {
  Annotation: {
    isOptimistic: () => false,
  },
  Mutation,
  AnnotationCoordinates: {
    identifier: () => uuid(),
  },
  Discover: {
    sections,
    contentHash,
  },
  Query: {
    /** These are @client data. This avoids the BE request */
    discover: () => ({
      __typename: 'Discover',
      sections: [],
      contentHash: 'some-hash',
    }),
    campaignSignUpContent,
    roleSignUpContent,
  },
}
